import { createFileRoute } from '@tanstack/react-router'
import { hasAccessToken } from '@/lib/token-storage'
import { redirectToLoginApp } from '@/lib/login-app-url'
import WorkspacePage from '@/pages/workspace/workspace'

export const Route = createFileRoute('/(auth)/workspace')({
  beforeLoad: () => {
    if (!hasAccessToken()) {
      throw redirectToLoginApp()
    }
  },
  component: WorkspacePage,
})
